<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <instrument-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import InstrumentForm from "./Form"
import model from "./model"

export default {
  components: { InstrumentForm },
  data() {
    return { model }
  },
}
</script>
